import './trade-card.styles'
import './trade-card.scss'

import { memo } from 'react'

import { TradingAccount } from '../../../../modules/draft-trades/types'
import { getBannerStateFromTradeStatus } from '../../../../types/tradeApproval'
import { Space } from '../..'
import { StateCircle } from '../../atoms/circle/StateCircle'

export type TradeCardProps = {
  isLiveTrade?: boolean
  isSelected?: boolean
  onClickAccount?: (accountId: string) => void
  trade: TradingAccount
}

const TradeCardInner = ({ isLiveTrade, isSelected, onClickAccount, trade }: TradeCardProps) => {
  let statusName = trade.status
  if (trade.isSwitch && trade.status === 'Pending settlement') {
    statusName = 'Pending activation'
  }
  if (trade.isSwitch && trade.status === 'Pending activation') {
    statusName = 'Activating'
  }
  const state = getBannerStateFromTradeStatus(statusName)
  let containerStyle = isSelected ? 'trade-item selected' : 'trade-item'
  if (isLiveTrade) {
    containerStyle = `${containerStyle} live`
  }

  return (
    <li className={containerStyle}>
      <Space mx={4} onClick={() => onClickAccount(trade.accountId)}>
        <Space py={3}>
          <div className="type" />
          <div className="trade-item-name">{trade.accountName}</div>
          <Space className="trade-item-portfolio-selected" mt={3}>
            {trade.portfolio}
          </Space>
          <Space
            isflex
            alignItems="center"
            className="trade-item-status"
            flexDirection="row"
            mt={3}
          >
            <StateCircle state={state} />
            <div>{statusName}</div>
          </Space>
        </Space>
      </Space>
    </li>
  )
}

const areEqual = (prevProps: TradeCardProps, nextProps: TradeCardProps) => {
  if (
    prevProps.trade.status === nextProps.trade.status &&
    prevProps.isSelected === nextProps.isSelected
  ) {
    return true
  }
  return false
}

export const TradeCard = memo(TradeCardInner, areEqual)
